import React from 'react'
import { useIntl } from 'react-intl'

import {
  Button,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'

import { useConditions } from 'Hooks'

const ModalStopCampaign = ({
  show,
  idList,
  idSending,
  idSource,
  mode,
  closeModal,
  handleConfirm,
  handleEdit,
  appendToDataMuTest
}) => {
  const intl = useIntl()
  const [canEdit] = useConditions(['uo:CONTENTSSOURCES'])

  return (
    <Modal
      show={show}
      showClose
      data-mu-test={`modal-stop-campaign-${appendToDataMuTest}`}
      onClose={closeModal}
    >
      <ModalHead title={intl.formatMessage({
        id: 'Load.Schedulation.stopSendingCampaignModalTitle'
      })}
      />
      <ModalBody>{intl.formatMessage({
        id: 'Load.Schedulation.stopSendingCampaignModalDescr'
      })}
      </ModalBody>
      <ModalFoot>
        {canEdit &&
          <Button
            kind='secondary'
            onClick={handleEdit}
          >{intl.formatMessage({
              id: 'Load.Schedulation.stopSendingCampaignModalSourceBtn'
            })}
          </Button>}
        <Button
          kind='primary'
          onClick={handleConfirm}
        >{intl.formatMessage({
            id: 'Load.Schedulation.stopSendingCampaignModalStopBtn'
          })}
        </Button>

      </ModalFoot>

    </Modal>
  )
}

export default ModalStopCampaign
